import { createContext, useContext } from 'react'

/** @type {ReturnType<typeof createContext<import("@googlemaps/markerclusterer").MarkerClusterer>>} */
const MarkerClustererContext = createContext(null)

export const MarkerClustererProvider = MarkerClustererContext.Provider

export const useMarkerClustererContext = () =>
    useContext(MarkerClustererContext)
